/* eslint-disable no-void */
import * as vp from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';

import { useDataFetchIndicator } from '..';

import vopayApi from '../../services/api.config';

type HookProps = { api: vp.Api };
type HookTuple = [
  response: vp.ApiResponse,
  SetDefaultBankAccount: (params: vp.SetMyBankAccountRequest) => void,
  reset: () => void,
];
type ApiHook = (props: HookProps) => HookTuple;

const usePostSetMyClientBankAccount: ApiHook = ({ api }) => {
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const [shouldSetDefaultBankAccount, setShouldSetDefaultBankAccount] = useState(false);
  const source = axios.CancelToken.source();
  const [params, setParams] = useState<vp.SetMyBankAccountRequest>({
    PortalUser: '',
    Token: '',
    SetAsDefault: false,
  });
  const [response, setResponse] = useState<vp.ApiResponse>({
    Success: false,
    ErrorMessage: '',
  });

  useEffect(() => {
    if (!shouldSetDefaultBankAccount) return () => {};

    const PostSetMyClientBankAccount = async () => {
      setDataFetchingInfo(true, 'Setting default account', 'fullScreen');
      const res = await api.postSetMyClientBankAccount(params, source);
      setResponse(res);
      setDataFetchingInfo(false);
    };

    if (shouldSetDefaultBankAccount) void PostSetMyClientBankAccount();
    setShouldSetDefaultBankAccount(false);
    return () => {
      source.cancel();
    };
  }, [shouldSetDefaultBankAccount]);

  return [
    response,
    (_params: vp.SetMyBankAccountRequest) => {
      setParams(_params);
      setShouldSetDefaultBankAccount(true);
    },
    () => {
      setResponse({
        Success: false,
        ErrorMessage: '',
      });
      setShouldSetDefaultBankAccount(false);
    },
  ];
};

export default vopayApi.withApiHook<HookProps, HookTuple>(usePostSetMyClientBankAccount);
